// ─── Frequency units ─────────────────────────────────────────────────────────
// Single source of truth for the Hz ↔ CPM conversion across the frontend.
// Replaces the scattered bare `* 60` / `/ 60` literals. Mirrors the backend's
// canonical_spectrum.CPM_PER_HZ so both sides speak the same constant.

export const CPM_PER_HZ = 60;

export const hzToCpm = (hz: number): number => hz * CPM_PER_HZ;
export const cpmToHz = (cpm: number): number => cpm / CPM_PER_HZ;
